























import { Vue, Component } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import CategoryTree from './category-tree.vue';
import * as api from '@/api';

/**
 * CTI目录搜索
 *
 * @author liyuyao
 * @date 09/06/2019
 */

@Component({
    components: {
        CategoryTree
    }
})
export default class SearchHeader extends Vue {
    @State(state => state.cti.userInfo)
    userInfo: CommonTypes.UserInfoItem;

    @State(state => state.cti.env)
    env: string;

    @State(state => state.cti.showAllCatalogs)
    showAllCatalogs: boolean;

    @Mutation setShowAllCatalogs;

    categoryList: any = [];

    mounted() {
        this.getCategoryTree();
    }
    get buttonText() {
        return this.showAllCatalogs ? '仅查看公共目录' : '查看全部目录';
    }

    handleCategoryChange(val) {
        this.$emit('change', val);
    }
    ctiTransfer() {
        this.$router
            .push({
                name: 'cti_transfer'
            })
            .catch(e => e);
    }
    showAllCatalogstoVuex(val) {
        this.setShowAllCatalogs(val);
        this.getCategoryTree();
    }
    get aboutUrl() {
        const url = this.env === 'prod' ? 'https://km.sankuai.com/collabpage/2734292781' : 'https://km.sankuai.com/collabpage/2734292781';
        return url;
    }
    async getCategoryTree() {
        try {
            const res = this.showAllCatalogs
                ? await api.ctiApi.getCategoryTree()
                : await api.spaceApi.getSpaceCatalogTree({
                      domain: 'public',
                      states: 1
                  });
            this.categoryList = res.data.items;
        } catch (e) {
            console.log(e);
        }
    }
}
